export default __webpack_public_path__ + "static/media/repo.5c4216cb.svg";